import React from 'react';
import { Drawer } from '../shared/Drawer';
import { useMediaQuery } from '@mui/material';
import { Button, Tooltip } from 'flowbite-react';
import { HiBriefcase, HiCurrencyRupee, HiLocationMarker, HiOutlineExternalLink } from 'react-icons/hi';
import { useUserContext } from 'src/context/UserProvider';
import { PiBuildingsLight } from 'react-icons/pi';
import { useNavigate } from 'react-router-dom';
import { useMutation } from 'react-query';
import { recordFETracking } from 'src/apis/tracking';
import { TrackingType } from 'types';

const RecruiterCreatePositionDrawer = ({ isOpen, onClose }: { isOpen: boolean; onClose: () => void }) => {
	const isMobile = useMediaQuery('(max-width:960px)');
	const { user } = useUserContext();
	const navigate = useNavigate();

	const recordFETrackingFn = useMutation(['recordFETracking'], recordFETracking, {
		onSuccess() {
			console.log('success tracking');
		},
		onError() {
			console.log('error');
		},
	});

	return (
		<div>
			<Drawer
				isOpen={isOpen}
				minHeight="fit-content"
				isModal={!isMobile}
				onClose={onClose}
				header={<></>}
				modalMaxWidth={isMobile ? '100%' : '460px'}
				backgroundColor="white"
				fullWidth={true}
				body={
					<div className="md:px-4 md:pt-9">
						<div className="bg-[#E5F0FF] md:rounded-[8px] px-4 pt-6 md:pt-4 pb-3 text-[#555770] md:text-[#28293D] text-sm md:text-base font-[500]">
							The current candidates match the job description mentioned.You can edit the job description, salary, and
							skills to find the perfect candidates.
						</div>
						<div className="p-4">
							<div className="rounded-[16px] border border-[#7777E7] p-3">
								<div className="flex gap-4">
									<div className="bg-[#FAFAFC] border max-w-[48px] flex justify-center items-center overflow-hidden min-w-[48px] max-h-[48px] min-h-[48px] rounded-full ">
										<PiBuildingsLight className="w-[24px] h-[24px]" />
									</div>
									<div>
										<div className="text-xl font-bold flex gap-3 items-center">Full Stack Engineer</div>
										<div className="flex cursor-pointer items-center gap-2 text-base font-medium text-[#6698FA] dark:text-inherit">
											{user?.registeredCompany?.name && user?.registeredCompany?.name?.length > 15 ? (
												<Tooltip content={user?.registeredCompany?.name} placement="top">
													<span className="hover:underline block truncate max-w-[15ch]">
														{user?.registeredCompany?.name}
													</span>
												</Tooltip>
											) : (
												<span className="hover:underline truncate max-w-[15ch]">{user?.registeredCompany?.name}</span>
											)}
										</div>
									</div>
								</div>

								<div className="mt-2">
									<div className="flex items-center">
										<HiBriefcase className="text-[#00B7C4] dark:text-[#A9EFF2] w-[20px] h-[20px]" />
										<div className="ml-1 flex items-center gap-1">
											<>
												Full-Time
												<div className="font-inter font-[500] text-[15px] leading-[16px] text-[#8F90A6] dark:text-[#C7C9D9]">
													•
												</div>
											</>
											<span>2+ yrs</span>
										</div>
									</div>

									<div className="mt-[12px] flex items-center">
										<HiCurrencyRupee className="text-[#00B7C4] dark:text-[#A9EFF2] w-[20px] h-[20px]" />
										<div className="ml-1">5.7 - 7 LPA</div>
									</div>

									<div className="mt-[12px] flex items-center">
										<HiLocationMarker className="text-[#00B7C4] dark:text-[#A9EFF2] w-[20px] h-[20px]" />
										<div className="ml-1 flex items-center gap-1">
											<>
												Bengaluru
												<div className="font-inter font-[500] text-[15px] leading-[16px] text-[#8F90A6] dark:text-[#C7C9D9]">
													•
												</div>
											</>
											<span>Remote</span>
										</div>
									</div>
								</div>

								<div className="mt-2">
									<div className="text-[#8F90A6] text-sm font-[500]">Skills required</div>
									<div className="flex items-center flex-wrap gap-3 mt-2">
										<div className="px-3 border-[0.5px] border-[#E2E8F0] bg-[#F8FAFC] text-[#555770] rounded-[6px]">
											React
										</div>
										<div className="px-3 border-[0.5px] border-[#E2E8F0] bg-[#F8FAFC] text-[#555770] rounded-[6px]">
											HTML
										</div>
										<div className="px-3 border-[0.5px] border-[#E2E8F0] bg-[#F8FAFC] text-[#555770] rounded-[6px]">
											CSS
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				}
				footer={
					<div className="p-[12px] flex items-center gap-5 justify-between  bg-[#FAFAFC] md:bg-white [filter:drop-shadow(0px_-2px_4px_rgba(49,_49,_49,_0.15))] md:filter-none border-t">
						<Button
							color="light"
							className="w-full max-w-max"
							onClick={() => {
								recordFETrackingFn.mutate({
									type: TrackingType.FLYWHEEL_CLICKED_BOOK_A_DEMO_ON_MODAL,
									createdAt: new Date(),
									meta: {
										url: window.location.href,
										userId: user?._id || '',
									},
								});
								// window.open(
								// 	user?.calendlyLink ||
								// 		'https://calendar.google.com/calendar/appointments/schedules/AcZssZ0jjmr3FjlpPj-tqKm1EKP-eDqWIwzNd__d9RStCG3HHT9MizG1-zoNIm6ekJSWggCm4dTYyQJP',
								// );
								window.open('https://calendar.app.google/1WagFr7sjC1XEZQz7');
							}}
						>
							Book a demo
						</Button>
						<Button
							color="purplePlaced"
							className="w-full"
							onClick={() => {
								recordFETrackingFn.mutate({
									type: TrackingType.FLYWHEEL_CLICKED_ON_JD,
									createdAt: new Date(),
									meta: {
										url: window.location.href,
										userId: user?._id || '',
									},
								});
								localStorage.setItem(
									'duplicatePosition',
									JSON.stringify({
										position: {
											title: 'FULL_STACK_ENGINEER',
											techStack: 'MERN',
											salary: {
												min: 5.7,
												max: 7,
											},
											positionRequirement: {
												workExperience: {
													min: 0,
													max: 2,
												},
												skillThresholds: [
													{
														displaySkill: 'React',
													},
													{
														displaySkill: 'HTML & CSS',
													},
												],
											},
											positionType: 'Remote',
										},
									}),
								);
								navigate('/create-position');
							}}
						>
							Review Job Description
						</Button>
					</div>
				}
			/>
		</div>
	);
};

export default RecruiterCreatePositionDrawer;

// {
// 	"position": {
// 		"_id": "6627ab3c1e3d5cc9fcc3b40b",
// 		"title": "SENIOR_SOFTWARE_ENGINEER",
// 		"description": "<ul>\n  <li>Roles and Responsibilities:</li>\n    <ul>\n      <li>Design, develop, and maintain software solutions for complex problems in the field of artificial intelligence and machine learning.</li>\n      <li>Collaborate with cross-functional teams to gather requirements, provide technical expertise, and ensure successful project delivery.</li>\n      <li>Create efficient and scalable code that adheres to industry best practices and coding standards.</li>\n      <li>Debug and resolve software defects, ensuring high-quality and reliable code.</li>\n      <li>Participate in code reviews to provide feedback and improve code quality.</li>\n      <li>Stay updated with new technologies, tools, and programming languages to enhance development efficiency and stay ahead in the industry.</li>\n    </ul>\n  <li>Additional Information about Flux.AI:</li>\n    <ul>\n      <li>Flux.AI is a cutting-edge artificial intelligence company that specializes in providing advanced solutions for various industries, including healthcare, finance, and e-commerce.</li>\n      <li>The company is known for its innovative and disruptive technologies that optimize business processes, enhance decision-making, and improve overall efficiency.</li>\n      <li>Flux.AI has a highly skilled and diverse team of professionals who are passionate about pushing the boundaries of AI and machine learning.</li>\n      <li>The company promotes a collaborative and inclusive culture, fostering an environment of continuous learning and growth.</li>\n      <li>Flux.AI values problem-solving skills, as the team is constantly tackling complex challenges and developing creative solutions.</li>\n      <li>Effective communication skills are crucial, as they facilitate collaboration among team members and enable effective knowledge sharing.</li>\n      <li>The company offers a competitive salary package and growth opportunities to its employees.</li>\n      <li>Flux.AI believes in work-life balance and provides a flexible work environment to support the well-being of its employees.</li>\n    </ul>\n</ul>",
// 		"createdByID": "6627a9bf1e3d5cc9fcc3ad85",
// 		"createdByName": "Rahim Ansari",
// 		"workLocation": "Remote",
// 		"workingMode": "FullTime",
// 		"internshipSalary": {
// 			"min": 0,
// 			"max": 0,
// 			"_id": "6627ab3c1e3d5cc9fcc3b409"
// 		},
// 		"internshipDuration": 0,
// 		"positionType": "Hybrid",
// 		"salary": {
// 			"min": 0,
// 			"max": 6,
// 			"_id": "6627ab3c1e3d5cc9fcc3b40c"
// 		},
// 		"vacancy": 2,
// 		"numberOfRounds": 3,
// 		"hired": 0,
// 		"isPublished": true,
// 		"bdpoc": "Aman",
// 		"positionStatus": "Open",
// 		"visibilityType": "OpenToAll",
// 		"positionRequirement": {
// 			"workExperience": {
// 				"min": 0,
// 				"max": 2,
// 				"_id": "6627ab3c1e3d5cc9fcc3b40f"
// 			},
// 			"goodToHaveskills": [
// 				"645399cd6f98fbd0a58d81af",
// 				"64539cbc6f98fbd0a58d81b0"
// 			],
// 			"skillThresholds": [
// 				{
// 					"displaySkill": "Problem Solving Skills",
// 					"skills": [
// 						{
// 							"isLockedSkill": false,
// 							"_id": "6454d5ae6f98fbd0a58d8234",
// 							"createdAt": "2023-05-05T10:08:46.945Z",
// 							"updatedAt": "2023-07-10T14:52:19.074Z",
// 							"name": "Problem Solving Skills",
// 							"isSellable": false,
// 							"type": "Skill",
// 							"assessTagRelationshipId": "6409a61c41ff9048e44b3f33",
// 							"isPractice": false,
// 							"isSoftSkill": false,
// 							"isResumeSkill": false
// 						}
// 					],
// 					"threshold": 418.1818181818182,
// 					"_id": "6627ab3c1e3d5cc9fcc3b410",
// 					"createdAt": "2024-04-23T12:36:12.214Z",
// 					"updatedAt": "2024-04-23T12:36:12.214Z"
// 				},
// 				{
// 					"displaySkill": "Communication Skills",
// 					"skills": [
// 						{
// 							"isSoftSkill": true,
// 							"isLockedSkill": false,
// 							"_id": "6455057b6f98fbd0a58d82c7",
// 							"createdAt": "2023-05-05T13:32:43.048Z",
// 							"updatedAt": "2023-05-05T13:32:43.048Z",
// 							"name": "Communication Skills",
// 							"isSellable": false,
// 							"type": "Skill",
// 							"assessTagRelationshipId": "6409a598086282ba27d3123b",
// 							"isPractice": false,
// 							"isResumeSkill": false
// 						}
// 					],
// 					"threshold": 400,
// 					"_id": "6627ab3c1e3d5cc9fcc3b411",
// 					"createdAt": "2024-04-23T12:36:12.214Z",
// 					"updatedAt": "2024-04-23T12:36:12.214Z"
// 				}
// 			],
// 			"levelThreshold": 392.4082618888819,
// 			"educationRequirements": [],
// 			"_id": "6627ab3c1e3d5cc9fcc3b40e",
// 			"createdAt": "2024-04-23T12:36:12.214Z",
// 			"updatedAt": "2024-04-23T12:36:58.023Z"
// 		},
// 		"positionStatusHistory": [
// 			{
// 				"updatedBy": "6627a9bf1e3d5cc9fcc3ad85",
// 				"newStatus": "Open",
// 				"_id": "6627ab3c1e3d5cc9fcc3b412",
// 				"createdAt": "2024-04-23T12:36:12.214Z",
// 				"updatedAt": "2024-04-23T12:36:12.214Z"
// 			}
// 		],
// 		"company": {
// 			"_id": "6627a87b336880caf938902e",
// 			"__v": 0,
// 			"accountManagers": [
// 				{
// 					"accountManager": "65d71686ddfd21ededb8f9a8",
// 					"type": "Primary",
// 					"_id": "6627a87b1e3d5cc9fcc38c8b",
// 					"createdAt": "2024-04-23T12:24:27.796Z",
// 					"updatedAt": "2024-04-23T12:24:27.796Z"
// 				},
// 				{
// 					"accountManager": "65d7166bddfd21ededb8f6af",
// 					"type": "Secondary",
// 					"_id": "6627a87b1e3d5cc9fcc38c8c",
// 					"createdAt": "2024-04-23T12:24:27.796Z",
// 					"updatedAt": "2024-04-23T12:24:27.796Z"
// 				}
// 			],
// 			"bdpoc": "Aman Vats",
// 			"brandScore": 0,
// 			"companyType": "SmallEnterprise",
// 			"createdAt": "2024-04-23T12:24:27.796Z",
// 			"createdByID": "6627a87b1e3d5cc9fcc38c5c",
// 			"createdByName": "Rahim Ansari",
// 			"isActive": true,
// 			"isBlacklisted": false,
// 			"isDisQualifiedLead": false,
// 			"isLead": false,
// 			"isQualifiedLead": false,
// 			"isSelf": true,
// 			"name": "Flux.AI",
// 			"nameHistory": [],
// 			"nature": "Product",
// 			"positions": [
// 				"6627ab3c1e3d5cc9fcc3b40b"
// 			],
// 			"rating": 0,
// 			"recruiter": [
// 				"6627a87b1e3d5cc9fcc38c5c",
// 				"6627a9bf1e3d5cc9fcc3ad85"
// 			],
// 			"stageScore": 0,
// 			"updatedAt": "2024-04-23T12:36:57.945Z"
// 		},
// 		"showLevelExplainer": false,
// 		"showGuidedTour": true,
// 		"tierType": "Tier4",
// 		"requestedRecommendations": false,
// 		"marketSalaryRange": {
// 			"min": 0,
// 			"max": 6,
// 			"_id": "6627ab3c1e3d5cc9fcc3b413"
// 		},
// 		"showFirstRecommendedCandidate": true,
// 		"visibleToAllRecruiters": false,
// 		"recruiters": [
// 			"6627a9bf1e3d5cc9fcc3ad85"
// 		],
// 		"requiredBTech": false,
// 		"underReview": false,
// 		"techStack": "ReactJs",
// 		"hasBond": false,
// 		"onlyForMasaiOneStudents": false,
// 		"hasConfirmedPublish": true,
// 		"isFaceToFacePosition": false,
// 		"interviewFormat": "Online",
// 		"hasAssignmentRound": false,
// 		"recommendations": [],
// 		"createdAt": "2024-04-23T12:36:12.214Z",
// 		"updatedAt": "2024-04-23T12:36:58.023Z",
// 		"expiresAt": "2024-04-24T08:36:58.016Z"
// 	},
// 	"recommendedUsers": 20,
// 	"connectedUsers": 0,
// 	"inPipeLineUsers": 0
// }
